<template>
    <div class="pay">
        <div class="title">支付完成</div>
        <div class="subtitle">支付方式</div>
        <div class="pay-type">
            <div class="pay-option" @click="onCheck">
                <div class="pay-title">
                    <span><van-icon name="/pay/weixin.png"/></span><span style="padding-left: 20px">微信</span>
                </div>
                <div class="pay-value"><van-checkbox icon-size="18px" checked-color="#ee0a24" v-model="wx"/></div>
            </div>

            <div class="pay-option" @click="onCheck">
                <div class="pay-title">
                    <span><van-icon name="/pay/zfb.png"/></span><span style="padding-left: 20px">支付宝</span>
                </div>
                <div class="pay-value"><van-checkbox icon-size="18px" checked-color="#ee0a24" v-model="zfb"/></div>
            </div>
        </div>

    </div>
    <div class="footer">
        <div class="total">合计 <span style="color: #F94B54"> {{ total_amount }} 元</span></div>
        <div class="payment" @click="interaction">完成支付</div>
    </div>
</template>
<script>

import {showFailToast, showSuccessToast} from "vant";
import ayzAjax from "@/plugins/axios";
import {isIOS, isWebView} from "@/assets/js/common";
export default {
    name: "AliView",
    data: function () {
        return {
            wx:false,
            zfb:true,
            type:2,
            params:[],
            total_amount:0,
            pay_status:0,
            pollInterval:null,
        }
    },
    created() {
        this.params = this.$route.query;
        console.log(this.params);
        if (this.params.total_amount !== undefined && this.params.total_amount > 0){
            this.total_amount = this.params.total_amount;
            this.startPolling(2000);
        }
    },
    methods: {
        fetchData() {
            //发送请求获取数据
            ayzAjax.post('/checkout/check_pay_status',this.params).then(response => {
                console.log(response);
                this.pay_status = response.data.data.pay;
                console.log('轮询' + this.pay_status);
                if(this.pay_status === 1){
                    this.stopPolling();
                    showSuccessToast('支付完成');
                    this.interaction();
                }
            })
            .catch(error => {
                showFailToast('未查询到支付信息,请前往订单页面查看');
                this.stopPolling();
                this.interaction();
                console.error('Error:', error);
            });
        },
        interaction(){
            if(isIOS() && isWebView()){
                let param = {};
                param.eventType = 3;//活动支付完成
                param = JSON.stringify(param)
                window.webkit.messageHandlers.ayz_interactive.postMessage(param);
            }
        },
        startPolling(interval) {
            this.pollInterval = setInterval(this.fetchData, interval); // 设置定时器，每interval毫秒调用一次fetchData
            setTimeout(function () {
                if (this.pollInterval) {
                    clearInterval(this.pollInterval); // 清除定时器
                    this.pollInterval = null; // 重置定时器ID
                    this.interaction();
                }
            },10000); //10秒自动结束轮询
        },

        stopPolling() {
            if (this.pollInterval) {
                clearInterval(this.pollInterval); // 清除定时器
                this.pollInterval = null; // 重置定时器ID
            }
        },
        onCheck(){
            this.wx = false;
            this.zfb = true;
        },

    }
}
</script>

<style scoped lang="scss" >
.pay{
    margin-top: 0;
    background: #FFFFFF;
    padding: 40px 20px 40px 30px;

    .title{
        color: #333333;
        font-size: 17px;
        font-weight: bold;
    }
    .subtitle{
        //margin-top: 20px;
        color: #121212;
        font-size: 15px;
        text-align: left;
        font-weight: bold;
        margin-top: 30px;
    }
    .pay-type{
        margin-top: 20px;
        text-align: left;
        .pay-option{
            margin-top: 20px;
            width: 100%;
            height: 30px;
            line-height: 30px;
            .pay-title{
                width: 150px;
                float: left;
            }
            .pay-value{
                width: 40px;
                float: right;
                margin-top: 8px;
            }
        }
    }

}
.footer{
    position: fixed;
    bottom: 0px;
    width: 100%;
    //display: flex;
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    padding-left: 30px;
    color: #222222;
    line-height: 50px;
    background: #FFFFFF;
    padding-top: 10px;
    padding-bottom: 10px;
    .total{
        //margin-top: 20px;
        float: left;
    }
    .payment{
        float: right;
        //margin-top: 20px;
        margin-right: 60px;
        width: 160px;
        height: 48px;
        line-height: 48px;
        background-color: #F94B54;
        color: #FFFFFF;
        text-align: center;
        border-radius: 10px;
    }

}



</style>